export function downloadFileFromPath(path: string) {
  if (!path) return;
  // Remove /api/v1 do final da base URL, se existir
  let baseUrl = import.meta.env.VITE_BASE_URL as string;
  if (baseUrl.endsWith('/api/v1')) {
    baseUrl = baseUrl.replace(/\/api\/v1\/?$/, '');
  }
  const url = path.startsWith('http') ? path : `${baseUrl}${path}`;
  window.open(url, '_blank');
}
